module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Offer History","title_table":"offer history for Allocation","close":"Close","client_id":"Afflo ID"},"fr":{"title":"Historique de l’offre","title_table":"historique de l’offre pour l’attribution","close":"Fermer","client_id":"No Afflo"},"en_tgln":{"client_id":"TGLN ID"},"fr_tgln":{"client_id":"No TGLN"},"en_tq":{"client_id":"TQ Number"},"fr_tq":{"client_id":"No TQ"}}')
  delete Component.options._Ctor
}
